import React from 'react';
import PropTypes from 'prop-types';
import './background.scss';

const Background = ({ background }) => {
	let backgroundClass = null;
	let backgroundStyle = null;

	if (
		background.backgroundId === 'custom' && 
		background.scenarioId
	) {
		backgroundClass = 'custom';
		backgroundStyle = {backgroundImage: 'url(' + background.scenarioId + ')'};
	} else {
		if (background && background.scenarioId === 'game1') {
			/* Game 1 backgrounds */
			backgroundClass = 'game1 ';
			switch (background.backgroundId) {
			case 'office':
				backgroundClass += 'office';
				break;
			case 'research':
				backgroundClass += 'research';
				break;
			case 'it':
				backgroundClass += 'it';
				break;
			case 'build':
				backgroundClass += 'build';
				break;
			case 'safety':
				backgroundClass += 'safety';
				break;
			case 'education':
				backgroundClass += 'education';
				break;
			case 'login':
				backgroundClass += 'login';
				break;
			case 'school':
				backgroundClass += 'school';
				break;		
			default:
				break;
			}
		} else if (background && background.scenarioId === 'game2') {
			/* Game 2 backgrounds */
			backgroundClass = 'game2 ';
			switch (background.backgroundId) {
			case 'login':
				backgroundClass += 'login';
				break;
			case 'school':
				backgroundClass += 'school';
				break;
			case 'office':
				backgroundClass += 'office';
				break;
			case 'sales':
				backgroundClass += 'sales';
				break;
			case 'it':
				backgroundClass += 'it';
				break;
			case 'economy':
				backgroundClass += 'economy';
				break;
			case 'investment':
				backgroundClass += 'investment';
				break;
			case 'education':
				backgroundClass += 'education';
				break;
			default:
				break;
			}
		} else if (
			background && 
			(background.scenarioId === 'game3' || background.scenarioId === 'game4')
		) {
			/* Game 3 backgrounds */
			backgroundClass = background.scenarioId + ' ';
			switch (background.backgroundId) {
			case 'school':
				backgroundClass += 'school';
				break;
			case 'education':
				backgroundClass += 'education';
				break;
			case 'fields':
				backgroundClass += 'fields';
				break;
			case 'logic':
				backgroundClass += 'logic';
				break;
			case 'social':
				backgroundClass += 'social';
				break;
			case 'subjectsHf':
				backgroundClass += 'subjects-hf';
				break;
			case 'login':
				backgroundClass += 'login';
				break;
			case 'teaching':
				backgroundClass += 'teaching';
				break;
			default:
				break;
			}
		} else if (background && background.scenarioId === 'game5') {
			/* Game 5 backgrounds */
			backgroundClass = background.scenarioId + ' ';
			
			switch (background.backgroundId) {
			case 'school':
				backgroundClass += 'school';
				break;
			case 'login':
				backgroundClass += 'login';
				break;
			case 'office':
				backgroundClass += 'office';
				break;
			case 'sales':
				backgroundClass += 'sales';
				break;
			case 'it':
				backgroundClass += 'it';
				break;
			case 'marketing':
				backgroundClass += 'marketing';
				break;
			case 'management':
				backgroundClass += 'management';
				break;
			case 'economy':
				backgroundClass += 'economy';
				break;
			default:
				break;
			}
		}
	}	
	return (
		<div className={'Background ' + background.scenarioId + ' ' + background.backgroundId}>
			<div style={backgroundStyle} className={'Background-' + backgroundClass} />
			<div className="Background-overlay" />
		</div>
	);
};

Background.propTypes = {
	background: PropTypes.object.isRequired,
};

export default Background;